import React, { useMemo } from "react";
import intl from "react-intl-universal";

import { ISelectOption } from "types";
import { ITeam } from "apis";

import { FIELD, STAT_METHOD_FREEKICK_OPTIONS } from "../../constants";

import { PlayerField } from "./PlayerField";
import { RadioField } from "./RadioField";
import { ThreatField } from "./ThreatField";

interface IMemoOptions {
  freekick: ISelectOption[];
}

interface IFreeKickPanelProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const FreeKickPanel = ({ homeTeam, awayTeam }: IFreeKickPanelProps) => {
  const options = useMemo<IMemoOptions>(
    () => ({
      freekick: STAT_METHOD_FREEKICK_OPTIONS.map((option) => ({
        label: intl.get(option.i18nTag),
        value: option.value,
      })),
    }),
    []
  );
  return (
    <>
      <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />
      <RadioField
        label={intl.get("STAT_FORM_LABEL_METHOD")}
        fieldName={FIELD.method}
        options={options.freekick}
      />
      <ThreatField />
    </>
  );
};
